import React, { Fragment } from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns } from '../../configuration';
import * as VatReturnRemindersListSelectors from '../../../../redux/reducers/vatReturn_reminders_reducer/selectors';
import { useDispatch } from 'react-redux';
import VatReturnRemindersListActions from '../../../../redux/reducers/vatReturn_reminders_reducer/actions';
import Filter from '../filter';
import useQuery from 'custom_hooks/useQuery';
import { useHistory } from 'react-router';
import NavigationConfig from '../../../../navigation/config';
import { parseQueryDate } from '../../../../utils/dates';

export default function DatatableList() {
  const result = VatReturnRemindersListSelectors.useGetVatReturnRemindersList();
  const paging = result.data?.paging || {
    page: 0,
    pageSize: 25,
    total: 0,
  };
  const dispatch = useDispatch();
  const history = useHistory();

  const query = useQuery();
  const sortField = query.get('sortField') || TableColumns[0].id;
  const order = (query.get('order') as 'asc' | 'desc') || 'desc';
  const vatNumber = query.get('vatNumber');
  const year = query.get('year');
  const period = query.get('period');
  const remindedDateFrom = query.get('remindedDateFrom');
  const remindedDateTo = query.get('remindedDateTo');

  return (
    <Fragment>
      <Filter
        vatNumber={vatNumber}
        year={year}
        period={period}
        remindedDateFrom={parseQueryDate(remindedDateFrom)}
        remindedDateTo={parseQueryDate(remindedDateTo)}
      />

      <Datatable
        loading={true}
        sorting={{
          sortField,
          order,
        }}
        paging={paging}
        data={result.data?.items || []}
        columns={TableColumns}
        changePageHandle={(selectedPage, pageSize, order, _sortField) => {
          const nextParams = new URLSearchParams(query.toString());
          nextParams.set('sortField', _sortField);
          nextParams.set('page', selectedPage.toString());
          nextParams.set('pageSize', pageSize.toString());
          nextParams.set('order', order);
          history.push(
            NavigationConfig.vatReturnRemindersPage().path +
              `?${nextParams.toString()}`
          );
          dispatch(
            VatReturnRemindersListActions.fetchVatReturnRemindersListListAction(
              {
                sortField: _sortField,
                page: selectedPage,
                pageSize: pageSize,
                order: order,
                ...(vatNumber && { vatNumber }),
                ...(year && { year }),
                ...(period && { period }),
                ...(remindedDateFrom && { remindedDateFrom }),
                ...(remindedDateTo && { remindedDateTo }),
              }
            )
          );
        }}
      />
    </Fragment>
  );
}
